import request from '@/utils/request'
//发送验证码
export function sendSms(data){
    return request({
        url:'/app/login/sendSms/'+ data,
        method:'post',
        timeout:20000
    })
}
//验证手机号与验证码是否一致
export function verifySms(data){
    return request({
        url:'/app/login/verifySms',
        data:data,
        method:'post',
        timeout:20000
    })
}


//查询版本号
export function selectVersion(data){
    return request({
        url:'/app-version/selectVersion',
        data:data,
        method:'post',
        timeout:20000
    })
}
